const Pagination = ({ currentPage, totalPages, onPageChange, maxPagesToShow = 5 }) => {

    const pageNumbers = [];

    if (totalPages <= maxPagesToShow) {
        // Show all pages if totalPages is less than 5
        for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else {
        // Sliding window of 5 pages around current page
        let startPage = currentPage - 2;
        let endPage = currentPage + 2;

        // Adjust if startPage < 1
        if (startPage < 1) {
            startPage = 1;
            endPage = 5;
        }

        // Adjust if endPage > totalPages
        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - 4;
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
    }

    return (
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => onPageChange(1)}>
                    &laquo;
                </button>
            </li>

            {/* Previous Page */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>
                    &lt;
                </button>
            </li>

            {/* Page Numbers */}
            {pageNumbers.map((num) => (
                <li key={num} className={`page-item ${num === currentPage ? "active" : ""}`}>
                    <button className="page-link" onClick={() => onPageChange(num)}>
                        {num}
                    </button>
                </li>
            ))}

            {/* Next Page */}
            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>
                    &gt;
                </button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => onPageChange(totalPages)}>
                    &raquo;
                </button>
            </li>
        </ul>
    );
};

export default Pagination;